export const USER_AUTH_KEY = '_baas_ua';
export const REFRESH_TOKEN_KEY = '_baas_rt';
export const DEVICE_ID_KEY = '_baas_did';
export const STATE_KEY = '_baas_state';
export const USER_AUTH_COOKIE_NAME = 'baas_ua';
export const STITCH_ERROR_KEY = '_baas_error';
export const STITCH_LINK_KEY = '_baas_link';
export const USER_LOGGED_IN_PT_KEY = '_baas_pt';
export const STITCH_REDIRECT_PROVIDER = '_baas_rp';

export const DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = 10;

export const APP_CLIENT_CODEC = {
  'accessToken': 'access_token',
  'refreshToken': 'refresh_token',
  'deviceId': 'device_id',
  'userId': 'user_id'
};

export const ADMIN_CLIENT_CODEC = {
  'accessToken': 'access_token',
  'refreshToken': 'refresh_token',
  'deviceId': 'device_id',
  'userId': 'user_id'
};



// WEBPACK FOOTER //
// ./src/auth/common.js